var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header-dropdown", {
    attrs: { position: "right" },
    scopedSlots: _vm._u([
      {
        key: "button",
        fn: function() {
          return [
            _c(
              "a",
              {
                staticClass: "k-menu__link position-relative",
                attrs: { href: "javascript:;" }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "k-menu__link-icon",
                    attrs: { role: "img", width: "25", height: "22" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        fill: "currentColor",
                        "xlink:href": "/images/spritesheet.svg#notification"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.notificationsCount > 0
                  ? _c("div", { staticClass: "k-notification-badge" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.notificationsCount) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "dropdown",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "k-notification-dropdown" },
              [
                _vm.notifications.length === 0
                  ? [
                      _c(
                        "a",
                        {
                          staticClass:
                            "k-notification-dropdown__item justify-content-center"
                        },
                        [_vm._v("Nemáte žádná nová upozornění")]
                      )
                    ]
                  : _vm._l(_vm.notifications, function(notification) {
                      return _c(
                        "a",
                        { staticClass: "k-notification-dropdown__item" },
                        [
                          notification.causer !== null
                            ? _c(
                                "div",
                                {
                                  staticClass: "k-notification-dropdown__image"
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        notification.causer.image ||
                                        "/images/placeholder.png",
                                      alt: ""
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "k-notification-dropdown__text" },
                            [
                              notification.causer !== null
                                ? [
                                    notification.causer.url !== null
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: notification.causer.url
                                              }
                                            },
                                            [
                                              _c(
                                                "strong",
                                                { staticClass: "k-strong" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      notification.causer.name
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(notification.causer.name)
                                            )
                                          ])
                                        ]
                                  ]
                                : _vm._e(),
                              _vm._v(
                                "\n\n                        " +
                                  _vm._s(notification.text) +
                                  "\n\n                        "
                              ),
                              notification.subject !== null
                                ? [
                                    notification.subject.url !== null
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: notification.subject.url
                                              }
                                            },
                                            [
                                              _c(
                                                "strong",
                                                { staticClass: "k-strong" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      notification.subject.title
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(notification.subject.title)
                                            )
                                          ])
                                        ]
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "k-user-dropdown__item k-user-dropdown__item--show-all",
                    attrs: { href: _vm.notificationsListLink }
                  },
                  [_vm._v("\n                Zobrazit všechny\n            ")]
                )
              ],
              2
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }